import * as z from "zod/v4";

const landedCostSettingsSchema_ = z.object({ enabled: z.boolean() });

export const landedCostSettingsSchema: z.ZodType<LandedCostSettings> =
  landedCostSettingsSchema_;
export interface LandedCostSettings
  extends z.infer<typeof landedCostSettingsSchema_> {}

export const landedCostSettingsDefault: LandedCostSettings = { enabled: false };
